import { createSelector } from 'reselect';

import calculateAgeFromDateOfBirth from '../../utils/calculate-age-from-date-of-birth';
import selectCustomer from '../select-customer';
import type { Customer } from '../select-customer/types';

export type MemberYouthDiscountAgesType = Record<string, number | null>;

const getCustomerAges = (customer: Partial<Pick<Customer, 'members'>> | null): MemberYouthDiscountAgesType =>
  (customer?.members ?? []).reduce<MemberYouthDiscountAgesType>(
    (ages, { dob, relationship }) => ({ ...ages, [relationship]: calculateAgeFromDateOfBirth(dob) }),
    {},
  );

export default createSelector(selectCustomer, getCustomerAges);

export { getCustomerAges };
